import { render, staticRenderFns } from "./nGramSlider.vue?vue&type=template&id=5b1719dc&"
import script from "./nGramSlider.vue?vue&type=script&lang=js&"
export * from "./nGramSlider.vue?vue&type=script&lang=js&"
import style0 from "./nGramSlider.vue?vue&type=style&index=0&id=5b1719dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports